
export const ValidateLogisticStationAdminFuncInput = (logisticStation, _createErrorMessage) => {
  if (!logisticStation) {
    _createErrorMessage("78");
    return false;
  }

  return true;
};
